import { WebGLRenderer } from 'three'

const NUM_FPS_SAMPLES = 64

export default class RendererDebugInfo {
  #renderer: WebGLRenderer
  fps = 0
  drawCalls = 0

  #fpsSamples: number[]
  #frame = 0

  constructor(renderer: WebGLRenderer) {
    this.#renderer = renderer

    this.#fpsSamples = Array(NUM_FPS_SAMPLES).fill(0)

    this.#frame = 0
  }

  resetBuffer() {
    this.#frame = 0
    this.#fpsSamples = Array(NUM_FPS_SAMPLES).fill(0)
  }

  calcFPS(dt: number, frame: number) {
    this.#fpsSamples[frame % NUM_FPS_SAMPLES] = 1 / dt
    let fps = 0
    for (let i = 0; i < NUM_FPS_SAMPLES; i++) {
      if (this.#fpsSamples[i] === 0 || this.#fpsSamples[i] === Infinity) {
        return 0
      }

      fps += this.#fpsSamples[i]
    }
    fps /= NUM_FPS_SAMPLES
    return fps
  }

  update(delta: number) {
    const result = this.calcFPS(delta, this.#frame)

    // only update once a second
    if (this.#frame % 60 === 0) {
      this.fps = Math.floor(result)
      this.drawCalls = this.#renderer.info.render.calls
    }

    this.#frame++
  }
}
